import React, { Component, Fragment } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import BasicSelect from './groups/BasicSelect';

class BehaviorSelect extends Component {
    static propTypes = {
        behaviors: PropTypes.array,
        abilities: PropTypes.array,
        behaviorsById: PropTypes.object,
        dimensionsById: PropTypes.object,
        abilitiesById: PropTypes.object,
        changeFormValue: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedAbilityId: '',
            availableBehaviors: []
        };
    }

    componentDidMount() {
        const { behaviors = [] } = this.props;
        this.setState(() => ({
            availableBehaviors: behaviors
        }));
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.behaviors, this.props.behaviors)) {
            this.setState(() => ({
                availableBehaviors: this.props.behaviors
            }));
        }
    }

    handleBehaviorSelection = (e, selectedBehaviorId) => {
        const { selectedAbilityId } = this.state;
        const { behaviorsById, changeFormValue } = this.props;
        let learningAssetAbility;
        if (!selectedAbilityId && selectedBehaviorId) {
            learningAssetAbility = behaviorsById[selectedBehaviorId] && behaviorsById[selectedBehaviorId].abilityId;
            changeFormValue({ field: 'abilityId', value: learningAssetAbility });
            this.handleAbilitySelection(null, learningAssetAbility);
        }
    };

    handleAbilitySelection = (e, selectedAbilityId) => {
        const { behaviors, abilitiesById, changeFormValue } = this.props;
        let availableBehaviors = behaviors;
        let learningAssetDimensionId = null;

        if (abilitiesById[selectedAbilityId] && abilitiesById[selectedAbilityId].dimensionId) {
            availableBehaviors = behaviors.filter((behavior) => behavior.abilityId === selectedAbilityId);
            learningAssetDimensionId = abilitiesById[selectedAbilityId] && abilitiesById[selectedAbilityId].dimensionId;
        }
        changeFormValue({ field: 'dimensionId', value: learningAssetDimensionId });

        this.setState({
            selectedAbilityId,
            selectedDimension: learningAssetDimensionId,
            availableBehaviors
        });
    };

    render() {
        const { dimensionsById = {}, abilities } = this.props;
        const { availableBehaviors } = this.state;
        const abilityOptions = abilities.map((ability) => {
            const abilityCopy = { ...ability };
            if (dimensionsById[ability.dimensionId]) {
                abilityCopy.name = `${abilityCopy.name} - ${dimensionsById[ability.dimensionId].name}`;
            }
            return abilityCopy;
        });

        return (
            <Fragment>
                <Field
                    name={'abilityId'}
                    component={BasicSelect}
                    labelTextId={'LABEL_ABILITY_AND_DIMENSION'}
                    labelDefault={'Ability - Dimension'}
                    onChange={this.handleAbilitySelection}
                    valueKey={'_id'}
                    labelKey={'name'}
                    options={abilityOptions}
                    className={'col-6'}
                />
                <Field
                    name={'behaviorId'}
                    component={BasicSelect}
                    labelTextId={'LABEL_BEHAVIORS'}
                    labelDefault={'Behavior'}
                    onChange={this.handleBehaviorSelection}
                    className={'col-6'}
                    options={availableBehaviors}
                    menuBuffer={15}
                    labelKey={'name'}
                    valueKey={'_id'}
                />
            </Fragment>
        );
    }
}
export default BehaviorSelect;
